















































import {Vue, Component, Prop, Mixins} from "vue-property-decorator";
import {AxiosError, AxiosRequestConfig, AxiosResponse} from "axios";
import ErrorMessage from "@/components/messages/ErrorMessage.vue";
import Loading from "@/components/Loading.vue";
import helper from "@/plugins/helper";
interface FormInput {
  type:String,
  items:[],
  name:String
}
class snackbar {
  enabled:boolean=false;
  text:string="";
  timeout:number = 5000;
  color:String="success";
}
@Component({
  components: {Loading, ErrorMessage},
})
export default class EForm<S> extends Vue{

  @Prop({default:false}) displayCancelButton!:boolean;
  @Prop({default:'POST'}) method!:string;
  @Prop({default:''}) title!:string;
  @Prop({}) action!:string;
  @Prop({default:2000}) maxWidth!:number;
  @Prop({}) data!:any;
  @Prop({default: "FormData"}) requestType!: "FormData" | "JSON";
  @Prop({default: true}) required!: boolean; // Form alanlarının zorunlu olup olmadığını belirler
  //@Prop() presetsInData!: Function;

  //@Prop({default : Array<FormInput>()}) inputs!:Array<FormInput>;
  cancelButtonLabel:string="Vazgeç";
  error:AxiosError|null = null;
  config:AxiosRequestConfig = {
    headers:[]
  };
  onFly:boolean=false;
  snackbar: snackbar = new snackbar();
  // v-form validliğini takip eden property
  valid: boolean = false;

  // --- Yeni Props Eklentileri ---
  @Prop({ default: false }) autoClose!: boolean;  // Gönderim sonrası dialog kapanması için
  @Prop({ default: false }) dialog!: boolean;      // Parent ile iki yönlü bağlama için
  // ------------------------------

  mounted(){
    //console.log("ss",this.inputs);
    if(this.method == null){
      this.method = "POST"
    }
  }
  reset(){
    this.error=null;
  }
  cancel(){
    this.$emit('cancel');
  }

  async onSubmit(e: Event) {
    let data = Object.assign({}, this.data);
    try {
      e.preventDefault();
      // Form validasyonunu kontrol ediyoruz (v-form sayesinde)
      const isValid = (this.$refs.vform as any).validate && (this.$refs.vform as any).validate();
      if (!isValid) {
        // Eğer validasyon başarısızsa, gönderimi iptal ediyoruz.
        //return;
      }
      this.onFly = true;
      let prom: any;
      let keys = Object.keys(data);
      keys.forEach(key => {
        if (Array.isArray(data[key])) {
          data[key] = JSON.stringify(data[key]);
        }
      })
      if (this.method == "POST") {
        //return;
        if (this.requestType == "JSON")
          prom = await this.$http.post(this.action, {
            data: data,
            sendJson: true
          });
        else
          prom = await this.$http.post(this.action, data);
      }
      if (this.method == "COPY") {
        prom = await Vue.prototype.$http.request({
          method: "COPY",
          responseType: "json",
          data: JSON.stringify(data),
          transformRequest: [function (data: any, headers: any) {
            return data;
          }],
          url: this.action
        });
        // prom = await<AxiosResponse> Vue.prototype.$http.copy(this.action,data)
      }
      if (this.method == "PUT") {
        prom = await this.$http.put(this.action, data)
      }
      if (this.method == "GET") {
        prom = await this.$http.get(this.action, data)
      }
      //console.log(prom.data);
      this.snackbar = new snackbar();
      this.snackbar.enabled = true;
      this.onFly = false;
      if (typeof prom.data.message != "undefined") {
        this.snackbar.text = prom.data.message
      } else if (typeof prom.data.messages != "undefined") {
        this.snackbar.text = prom.data.messages
      } else {
        this.snackbar.text = "İşlem başarılı.";
      }
      this.$emit("success", prom.data);
      // autoClose prop'u true ise, dialog kapanması için update event'i yayalım.
      if (this.autoClose) {
        this.$emit("update:dialog", false);
      }
    } catch (error) {
      console.error('HATA', error.message);
      this.snackbar = new snackbar();
      this.snackbar.color = "error";
      this.onFly = false;
      this.snackbar.text = this.$helper.errorHandler(error);
      this.snackbar.enabled = true;
      /*
      if(typeof e.data.message != "undefined"){
          this.snackbar.text = e.data.message
      }else{
          this.snackbar.text = e.message;
      }
      */
    }

    /*
    //request<T = any, R = AxiosResponse<T>> (config: AxiosRequestConfig): Promise<R>;
    Vue.prototype.$http.request(this.config).then( (response:AxiosResponse)=>{
        this.$emit('success', response.data );
    }).catch( (error:AxiosError)=>{
        this.error = error;
    }).finally( ()=>{
        this.onFly=false;
    });
    */
  }
}

